import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateAirport } from "../../api/apiAirports";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdateAirport = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updateAirportAction, isPending } = useMutation({
        mutationFn: ({ id, data }) => updateAirport(id, data),
        onSuccess: (res) => {
            const message = res?.message || "Airport updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airports"] });
            navigate("/airports");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update airport");
        },
    });

    return { updateAirport: updateAirportAction, isPending };
};

export default useUpdateAirport;
